// AUTO-GENERATED from the live ester1.fi content (DatoCMS export).
// Safe to hand-edit: this is now the source of truth for site content.

const { asset } = require('./assets');

const tyylit = {
  seoMetaTags: {
    tags: [
      {
        tagName: "title",
        content: "Tyyli & Sisustus | Ester1",
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:title",
          content: "Tyyli & Sisustus",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:title",
          content: "Tyyli & Sisustus",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "description",
          content: "Ammattilaisen suunnittelemassa työtilassa inspiraation aistii ilmassa, idea sinkoilevat ja tuotteliaisuus kukoistaa. Valitkaa siis juuri teidän työkulttuuriinne sopiva tyyli kolmesta vaihtoehdosta \ntai tilatkaa oma tilasuunnittelu.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:description",
          content: "Ammattilaisen suunnittelemassa työtilassa inspiraation aistii ilmassa, idea sinkoilevat ja tuotteliaisuus kukoistaa. Valitkaa siis juuri teidän työkulttuuriinne sopiva tyyli kolmesta vaihtoehdosta \ntai tilatkaa oma tilasuunnittelu.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:description",
          content: "Ammattilaisen suunnittelemassa työtilassa inspiraation aistii ilmassa, idea sinkoilevat ja tuotteliaisuus kukoistaa. Valitkaa siis juuri teidän työkulttuuriinne sopiva tyyli kolmesta vaihtoehdosta \ntai tilatkaa oma tilasuunnittelu.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:card",
          content: "summary",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "article:modified_time",
          content: "2021-03-30T06:42:52Z",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "article:published_time",
          content: "2019-12-30T16:24:51Z",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:locale",
          content: "fi_FI",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:type",
          content: "article",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:site_name",
          content: "Ester1 – toimistotila keskellä uutta Pasilaa ",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:image",
          content: "/content-images/1614434200-toimistokeittiolammin02-2021.jpg",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:image",
          content: "/content-images/1614434200-toimistokeittiolammin02-2021.jpg",
        },
      },
    ],
  },
  title: "Tyyli & Sisustus",
  lead: "Ammattilaisen suunnittelemassa työtilassa inspiraation aistii ilmassa, idea sinkoilevat ja tuotteliaisuus kukoistaa. Valitkaa siis juuri teidän työkulttuuriinne sopiva tyyli kolmesta vaihtoehdosta \ntai tilatkaa oma tilasuunnittelu.",
  content: "",
  heroLayer: {
    alpha: 0,
    blue: 0,
    green: 0,
    red: 0,
  },
  imgHero: asset("1614434200-toimistokeittiolammin02-2021.jpg", {
    sizes: "(max-width: 1600px) 100vw, 1600px",
    aspectRatio: 1.765977,
  }),
  otsikko1: "Sisustustyylit",
  otsikko2: "Sisustus-arkkitehti viimeistelee",
  teksti2: "<p>Suunnittelijan avulla tehostatte tilank&auml;ytt&ouml;&auml;, sovitatte tyylin br&auml;ndinne mukaiseksi ja viimeistelette yksityiskohdat. Sisustussuunnittelijamme viimeistelee valitun tyylinne, <a href=\"/tilaratkaisu\"><strong>kysy lis&auml;&auml;</strong></a>.</p>\n<p>Sisustussuunnittelijan toteuttama oma tyyli on tilattavissa lis&auml;hintaan. Kysy tarkempi <strong><a href=\"#bottom\">tarjous omasta tyylist&auml;si</a>.</strong>&nbsp;</p>",
  kuva2: asset("1616145336-uniikki-nelio2-min.jpg", {
    sizes: "(max-width: 620px) 100vw, 620px",
    aspectRatio: 1.005435,
  }),
};

module.exports = { tyylit };
